export enum invoicesListTypes {
    GET_INVOICES_LIST = '@@invoicesList/GET_invoices_List',
    GET_INVOICES_LIST_SUCCESS = '@@invoicesList/GET_invoices_List_SUCCESS',
    GET_INVOICES_LIST_FAIL = '@@invoicesList/GET_invoices_List_FAIL',
  
    GET_MILESTONESCONFIG_IN = "@IN/GET_MILESTONECONFIG",
    GET_MILESTONESCONFIG_IN_SUCCESSS = "@IN/GET_MILESTONECONFIG_SUCCESS",
    GET_MILESTONESCONFIG_IN_FAIL = "@IN/GET_MILESTONECONFIG_FAIL"
  }
  